import { render, staticRenderFns } from "./MandatePage.vue?vue&type=template&id=486a3a6b&scoped=true&"
import script from "./MandatePage.vue?vue&type=script&lang=js&"
export * from "./MandatePage.vue?vue&type=script&lang=js&"
import style0 from "./MandatePage.vue?vue&type=style&index=0&id=486a3a6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a3a6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486a3a6b')) {
      api.createRecord('486a3a6b', component.options)
    } else {
      api.reload('486a3a6b', component.options)
    }
    module.hot.accept("./MandatePage.vue?vue&type=template&id=486a3a6b&scoped=true&", function () {
      api.rerender('486a3a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandatePage.vue"
export default component.exports